import {styled} from '@mui/material/styles';
import {flexRender} from '@tanstack/react-table';
import React from 'react';

import {pxToRem} from '../../utils';

const StyledTableBodyCell = styled('td')(({theme}) => ({
  padding: `${pxToRem(12)} ${pxToRem(16)}`,
  position: 'relative',
  borderBottom: `${pxToRem(1)} solid ${theme.palette.grey[200]}`,
  wordWrap: 'break-word',
  maxWidth: pxToRem(200),
  whiteSpace: 'normal',
}));

const TableBody = ({rows}) => {
  return (
    <tbody>
      {rows.map((row) => {
        return (
          <tr key={row.id}>
            {row.getVisibleCells().map((cell) => {
              return (
                <StyledTableBodyCell key={cell.id}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </StyledTableBodyCell>
              );
            })}
          </tr>
        );
      })}
    </tbody>
  );
};

const MemoizedTableBody = React.memo(TableBody, (prevProps, nextProps) => {
  return (
    prevProps.rows === nextProps.rows &&
    prevProps.columnVisibility === nextProps.columnVisibility &&
    prevProps.triggerUpdateTableData === nextProps.triggerUpdateTableData
  );
});

export default MemoizedTableBody;
